module.exports = __webpack_public_path__ + "static/img/zhizhu3.c6f6183.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhizhu3.png
// module id = Q4uP
// module chunks = 51